var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CopyToSelectInput',{on:{"removed":_vm.removed},model:{value:(_vm.copy_tos_proxy),callback:function ($$v) {_vm.copy_tos_proxy=$$v},expression:"copy_tos_proxy"}})
}
var staticRenderFns = []

export { render, staticRenderFns }